













































import { Component, Emit, VModel } from 'vue-property-decorator'

import WindowResizeMixin from '../../../../../../../../../../logic/helpers/WindowResizeMixin'
import { MessageNodeActionTypes } from '../../../logic/types'

@Component({
  data() {
    return {
      MessageNodeActionTypes,
    }
  }
})
export default class SendMessageAddNewActionModal extends WindowResizeMixin {
  @VModel() isOpen!: boolean

  @Emit()
  createNewAction(actionType: MessageNodeActionTypes): MessageNodeActionTypes {
    return actionType
  }
}
